import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
// import { useHistory } from "react-router-dom";
import "./Nav.css";
import { useAuthState } from "react-firebase-hooks/auth";
import { auth } from "./firebase.init";

function Nav() {
  const [show, handleShow] = useState(false);
  const navigate = useNavigate();
  const user = useAuthState(auth)

  const transitionNavBar = () => {
    if (window.scrollY > 100) {
      handleShow(true);
    } else {
      handleShow(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", transitionNavBar);
    return () => window.removeEventListener("scroll", transitionNavBar);
  }, []);

  return (
    <div className={`nav ${show && "nav__black"}`}>
      <div className="nav__contents">
        {
          user ?
          <img
          onClick={() => navigate("/home")}
          className="nav__logo"
          src="https://i.ibb.co/7bWX0YV/Acq.png"
          alt=""
        />
        :
        <img
          onClick={() => navigate("/")}
          className="nav__logo"
          src="https://i.ibb.co/7bWX0YV/Acq.png"
          alt=""
        />
        }
        <div className="nav-link-container">
          <div className="nav-element">Home</div>
          <div className="nav-element">Live</div>
          <div className="nav-element">TV</div>
          <div className="nav-element">Movies</div>
          <div className="nav-element">Sports</div>
          <div className="nav-element">My Stuff</div>
        </div>
        <div className="nav-link-dropdown">
          <select name="all" id="options">
            <option value="Home">Home</option>
            <option value="Live">Live</option>
            <option value="TV">TV</option>
            <option value="Movies">Movies</option>
            <option value="Movies">Sports</option>
            <option value="Movies">My Stuff</option>
          </select>
        </div>
        <img
          onClick={() => navigate("/profile")}
          className="nav__avatar"
          src="https://srcwap.com/wp-content/uploads/2022/08/abstract-user-flat-4.png"
          alt=""
        />
      </div>
    </div>
  );
}

export default Nav;
